import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { useMemo } from 'react';
import { TabsProvider, useTabsContext } from './TabsContext';
const styles = {
    scroll: css({
        '&::-webkit-scrollbar': {
            height: '7px',
            width: '7px',
        },
        '&::-webkit-scrollbar-track': {
            backgroundColor: 'rgba(0,0,0,.05)',
        },
        '&::-webkit-scrollbar-thumb': {
            backgroundColor: 'rgba(0,0,0,.2)',
        },
    }),
    item: (isSelected, orientation) => {
        return css([
            {
                padding: '0.25em 1em',
                border: '1px solid hsl(0deg, 0%, 80%)',
                fontSize: '1.125em',
                ':hover': {
                    backgroundColor: 'hsl(0deg, 0%, 90%)',
                },
                whiteSpace: 'nowrap',
            },
            isSelected && {
                backgroundColor: 'hsl(0deg, 0%, 95%)',
                ':hover': {
                    backgroundColor: 'hsl(0deg, 0%, 90%)',
                },
            },
            orientation === 'horizontal' && {
                margin: '0px 2px 0px 2px',
                borderBottom: 'none',
            },
            orientation === 'vertical' && {
                margin: '2px 0px 2px 0px',
                borderRight: 'none',
            },
        ]);
    },
};
export function Tabs(props) {
    const { orientation = 'horizontal', items, onClick, opened } = props;
    const item = useMemo(() => items.find(({ id: itemId }) => itemId === opened), [items, opened]);
    if (orientation === 'horizontal') {
        return (_jsx(TabsProvider, { opened: item, children: _jsx(TabsHorizontal, { items: items, onClick: onClick }) }));
    }
    return (_jsx(TabsProvider, { opened: item, children: _jsx(TabsVertical, { items: items, onClick: onClick }) }));
}
function TabsItem(props) {
    const item = useTabsContext();
    return (_jsx("button", { type: "button", onClick: props.onClick, css: styles.item(item?.id === props.id, props.orientation), children: props.title }));
}
function TabsVertical(props) {
    const { items, onClick } = props;
    const item = useTabsContext();
    return (_jsxs("div", { style: {
            display: 'flex',
            flexDirection: 'row',
            flex: '1 1 0%',
            overflowY: 'hidden',
            height: '100%',
        }, children: [_jsx("div", { style: {
                    display: 'flex',
                    flexDirection: 'column',
                    borderRight: '1px solid hsl(0deg, 0%, 80%)',
                    overflowY: 'auto',
                }, css: styles.scroll, children: items.map((item) => (_jsx(TabsItem, { orientation: "vertical", title: item.title, id: item.id, onClick: () => {
                        onClick?.(item.id);
                    } }, item.id))) }), item && (_jsx("div", { style: { flex: '1 1 0%', overflowX: 'auto' }, children: item.content }))] }));
}
function TabsHorizontal(props) {
    const { items, onClick } = props;
    const item = useTabsContext();
    return (_jsxs("div", { style: {
            display: 'flex',
            flexDirection: 'column',
            overflowX: 'hidden',
            height: '100%',
        }, children: [_jsx("div", { style: {
                    display: 'flex',
                    flexDirection: 'row',
                    borderBottom: '1px solid hsl(0deg, 0%, 80%)',
                    overflowX: 'auto',
                }, css: styles.scroll, children: items.map((item) => (_jsx(TabsItem, { orientation: "horizontal", id: item.id, title: item.title, onClick: () => {
                        onClick?.(item.id);
                    } }, item.id))) }), item && (_jsx("div", { style: { flex: '1 1 0%', overflowX: 'auto' }, children: item.content }))] }));
}
//# sourceMappingURL=Tabs.js.map